enum CuratorStatuses {
  ACTIVE = 'active',
  SICK_LEAVE = 'sickLeave',
  VACATION = 'vacation',
}

export default CuratorStatuses
